import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FilterParams } from 'starbase-launcher/public_api';
import { WebApiService } from 'starbase-login';
import { TransactionDashService, TransactionLogModel } from 'transaction-dash';

@Injectable({
  providedIn: 'root'
})
export class TransactionLogService extends TransactionDashService {
  protected _getLogsByDateRangeUri = '/api/TransactionLog/DateRange';
  protected _staleDataTimeout = 1000;
  protected _getOneUri = '/api/TransactionLog/';
  protected _getAllUri = '/api/TransactionLog';
  protected _postUri = '/api/TransactionLog';
  protected _putUri = '/api/TransactionLog/';
  protected _deleteUri = '/api/TransactionLog/';
  protected _broadSearchUri = '/api/TransactionLog/GetTransactionsByFilterParams';
  protected _retrieveInvoiceFromVendorUri = '/api/FortisSubscription/RetrieveInvoiceById?invoiceId=';
  protected _getExcelReportUri = '/api/TransactionLog/GetTransactionExcelReport';

  constructor(private _http: HttpClient, private _webApi: WebApiService) {
    super(_http, _webApi);
  }

  getExcelReport(filterParams: FilterParams<TransactionLogModel>) {
    filterParams.collection = null;
    return this._http.post<File>(
      this.server + this._getExcelReportUri,
      filterParams,
      { headers: this._webApi.getApiHeaders('post'), responseType: 'blob' as 'json' }
    );
  }
}
